<template>
  <v-chart :options="option" v-if="isShow" ref="chart"></v-chart>
</template>

<script>
import 'echarts/lib/chart/line'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import util from '@/util/util.js'
export default {
  props: {
    list: {
      default: () => []
    }
  },
  watch: {
    list (nv) {
      this.option.series[0].data = nv
      this.option.xAxis.data = util.getPastSevenDate(true)
      this.isShow = true
    }
  },
  data () {
    let that = this
    return {
      isShow: false,
      option: {
        grid: {
          height: '85%',
          width: '85%',
          x: 'center',
          y: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: [],
          axisLabel: {
            margin: 10
          },
          axisLine:{
            show: false,
            lineStyle: {
              color: '#FFF'
            }
          },
          axisTick: {
            length: 0
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine:{
            lineStyle: {
              color: 'none'
            }
          },
          splitLine: {
            lineStyle:{
              color: '#333'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#CCC'
            }
          }
        },
        series:[{
          data: [200, 1500, 901, 934, 200, 1330, 1320],
          type: 'line',
          name: 'Transaction',
          smooth: true,
          symbol: 'none',
          itemStyle: {
            normal: {
              color: '#00B8FF',
              lineStyle: {
                color: '#00B8FF'
              }
            }
          }
        }]
      }
    }
  },
  async mounted () {
    let that = this
    window.addEventListener('resize', () => {
      try{
        that.$refs.chart.resize()
      }catch(e){}
    })
  }
}
</script>

<style lang="less" scoped>

</style>